import { Component, OnInit } from '@angular/core';
import { AlertService } from '../../servicios/alert.service';
import { loading_show, loading_hide } from '../../app.helpers';
import { Result } from '../../servicios/servers.service';
import { PersonaService } from '../../servicios/persona.service';
declare var jQuery: any;

@Component({
    selector: 'configuraciones',
    templateUrl: 'configuraciones.template.html'
})

export class ConfiguracionesComponent implements OnInit {

    constructor(
        private alertService: AlertService,
        private personaService: PersonaService
    ) {

    }

    ngOnInit() {
        this.getConfiguracion();
    }
    public filter = "";
    public configuracion:any = {};
    public update = false;
    
    getConfiguracion(){
        loading_show();
        this.personaService.getConfiguraciones((data: Result) => {
            loading_hide();
            
            if (data.isOk) {
                this.configuracion = data.Content;
            }

        });
    }

    saveConfiguraciones() {
    

        var object = {
            'descuentoCarrera': this.configuracion['descuentoCarrera'],
            'covertura': this.configuracion['covertura'],
        }
        console.log(object);
        //formData.append('empresa', JSON.stringify(object));

        loading_show();
        this.personaService.saveConfiguraciones(object, (data: Result) => {
            loading_hide();

            if (data.isOk) {
                this.getConfiguracion();
                this.alertService.success(data.Mensaje);
            }
        });

    }

}


// WEBPACK FOOTER //
// ./src/app/views/configuraciones/configuraciones.component.ts